import React from 'react';
import Button from '../ui/Button';
import '../../styles/components/profile_page/ManageBar.css';

export default function ManageBar({
  selectedCount,
  albums,
  currentAlbum,
  onMoveTo,
  onDelete,
  onSetCover,
  onDone,
}) {
  const albumNames = Object.keys(albums);
  const canSetCover = selectedCount === 1;
  const canDelete = selectedCount > 0;

  return (
    <div className="managebar managebar--sticky">
      <div className="managebar__left">
        <span className="managebar__selected">{selectedCount} selected</span>

        <div className="managebar__move">
          <select
            className="managebar__select"
            defaultValue=""
            onChange={(e) => e.target.value && onMoveTo(e.target.value)}
            disabled={!canDelete}
          >
            <option value="" disabled>Move to…</option>
            {albumNames.map((name) => (
              <option key={name} value={name} disabled={name === currentAlbum}>
                {name}
              </option>
            ))}
          </select>
        </div>

        {/* Guard in handler and mark visually inert */}
        <Button
          size="sm"
          variant="secondary"
          className={!canSetCover ? 'btn-inert' : ''}
          aria-disabled={!canSetCover}
          onClick={() => { if (canSetCover) onSetCover(); }}
        >
          Set as cover
        </Button>

        <Button
          size="sm"
          variant="danger"
          className={!canDelete ? 'btn-inert' : ''}
          aria-disabled={!canDelete}
          onClick={() => { if (canDelete) onDelete(); }}
        >
          Delete
        </Button>
      </div>

      <div className="managebar__right">
        <Button size="sm" variant="secondary" onClick={onDone}>Done</Button>
      </div>
    </div>
  );
}